import React, { useState } from 'react';
import Button from 'shared/components/button/Button';

const ActivationMessage = props => {
  let search = props.location.search;
  let params = new URLSearchParams(search);
  let name = params.get('name');
  let type = params.get('type');
  const [getStarted, setGetStarted] = useState(false);

  if (getStarted) {
    return (window.location = `${process.env.REACT_APP_DYNAMIC_LINK_DOMAIN}${type}_login`);
  }
  return (
    <div className="activation-page">
      <div className="activation-content">
        <h3 className="welcome-msg">
          Welcome, {name}! <br /> Download the Hybrid App to Begin
        </h3>
        <div className="form-action">
          <Button
            id=""
            type="submit"
            btnBlock="block"
            color="primary"
            label="Get Started"
            onClick={() => setGetStarted(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default ActivationMessage;
